// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Luxembourg from '../_raw/flag/icon_flag_luxembourg.png';

export default () => <img src={Luxembourg} alt="Luxembourg" />;
